module.exports = __webpack_public_path__ + "static/media/6_Prepare-Existing-Transformer-Cable-ConnectorLabel2.ab9f18e9.svg";